import React, { useState } from 'react';
import { Box, ClickAwayListener } from '@mui/material';
import { IoChevronDown } from 'react-icons/io5';
import { twMerge } from 'tailwind-merge';
import { Loader } from 'src/components';
import { DocumentResponse } from 'src/pages/CandidateDocuments/types';
import SectionHeaderRow, { SectionAddButton } from '../SectionHeaderRow';
import JobDocumentsList from './JobDocumentsList';

export interface JobDocumentsProps {
  loading: boolean;
  documentList: DocumentResponse[];
  onDocumentDownload: (doc: DocumentResponse) => void;
  onDocumentView: (doc: DocumentResponse) => Promise<void>;
  onDocumentDelete: (doc: DocumentResponse) => Promise<void>;
  onOpenDocumentAddPopup: () => Promise<void>;
}

function JobDocuments(props: JobDocumentsProps) {
  const {
    loading,
    documentList,
    onDocumentDownload,
    onDocumentView,
    onDocumentDelete,
    onOpenDocumentAddPopup,
  } = props;

  const [listOpen, setListOpen] = useState(false);

  const handleAddDocument = (e: React.MouseEvent) => {
    e.stopPropagation();
    onOpenDocumentAddPopup();
  };

  return (
    <ClickAwayListener onClickAway={() => setListOpen(false)}>
      <Box className="w-full">
        <SectionHeaderRow
          left={(
            <button
              type="button"
              onClick={() => setListOpen((prev) => !prev)}
              className="flex items-center gap-1 border-none bg-transparent p-0 cursor-pointer"
              aria-expanded={listOpen}
            >
              <Box className="font-bold text-sm leading-5">Documents</Box>
              {documentList.length > 0 && (
                <Box className="text-xs leading-5 text-[#828A97]">
                  (
                  {documentList.length}
                  )
                </Box>
              )}
              <IoChevronDown
                className={twMerge(
                  'h-4 w-4 text-[#828A97] transition-transform',
                  listOpen && 'rotate-180',
                )}
              />
            </button>
          )}
          action={(
            <SectionAddButton
              label="Add Document"
              onClick={handleAddDocument}
            />
          )}
        />

        {listOpen && (
          <Box className="mt-1">
            <JobDocumentsList
              documentList={documentList}
              onDocumentDownload={onDocumentDownload}
              onDocumentView={onDocumentView}
              onDocumentDelete={onDocumentDelete}
            />
          </Box>
        )}

        {loading && listOpen && (
          <Box className="fixed top-[50vh] left-[50vw]">
            <Loader />
          </Box>
        )}
      </Box>
    </ClickAwayListener>
  );
}

export default JobDocuments;
